// This file configures client-side instrumentation in Next.js 15.3+
// It is auto-discovered by Next.js and runs before your application's frontend code starts executing.
// https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/6529-gradient/:id\",\"regex\":\"^/6529-gradient/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:user\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"user\"],\"hasOptionalPrefix\":false},{\"path\":\"/:user/brain\",\"regex\":\"^/([^/]+)/brain$\",\"paramNames\":[\"user\"],\"hasOptionalPrefix\":false},{\"path\":\"/:user/collected\",\"regex\":\"^/([^/]+)/collected$\",\"paramNames\":[\"user\"],\"hasOptionalPrefix\":false},{\"path\":\"/:user/followers\",\"regex\":\"^/([^/]+)/followers$\",\"paramNames\":[\"user\"],\"hasOptionalPrefix\":false},{\"path\":\"/:user/groups\",\"regex\":\"^/([^/]+)/groups$\",\"paramNames\":[\"user\"],\"hasOptionalPrefix\":false},{\"path\":\"/:user/identity\",\"regex\":\"^/([^/]+)/identity$\",\"paramNames\":[\"user\"],\"hasOptionalPrefix\":false},{\"path\":\"/:user/proxy\",\"regex\":\"^/([^/]+)/proxy$\",\"paramNames\":[\"user\"],\"hasOptionalPrefix\":false},{\"path\":\"/:user/subscriptions\",\"regex\":\"^/([^/]+)/subscriptions$\",\"paramNames\":[\"user\"],\"hasOptionalPrefix\":false},{\"path\":\"/:user/waves\",\"regex\":\"^/([^/]+)/waves$\",\"paramNames\":[\"user\"],\"hasOptionalPrefix\":false},{\"path\":\"/:user/xtdh\",\"regex\":\"^/([^/]+)/xtdh$\",\"paramNames\":[\"user\"],\"hasOptionalPrefix\":false},{\"path\":\"/about/:section\",\"regex\":\"^/about/([^/]+)$\",\"paramNames\":[\"section\"],\"hasOptionalPrefix\":false},{\"path\":\"/delegation/:section*\",\"regex\":\"^/delegation/(.+)$\",\"paramNames\":[\"section\"],\"hasOptionalPrefix\":false},{\"path\":\"/drop-forge/craft/:id\",\"regex\":\"^/drop-forge/craft/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/drop-forge/launch/:id\",\"regex\":\"^/drop-forge/launch/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/emma/plans/:id\",\"regex\":\"^/emma/plans/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/meme-lab/:id\",\"regex\":\"^/meme-lab/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/meme-lab/:id/distribution\",\"regex\":\"^/meme-lab/([^/]+)/distribution$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/meme-lab/collection/:collection\",\"regex\":\"^/meme-lab/collection/([^/]+)$\",\"paramNames\":[\"collection\"],\"hasOptionalPrefix\":false},{\"path\":\"/network/nerd/:focus*?\",\"regex\":\"^/network/nerd(?:/(.*))?$\",\"paramNames\":[\"focus\"],\"hasOptionalPrefix\":false},{\"path\":\"/nextgen/:view*?\",\"regex\":\"^/nextgen(?:/(.*))?$\",\"paramNames\":[\"view\"],\"hasOptionalPrefix\":false},{\"path\":\"/nextgen/collection/:collection/:view*?\",\"regex\":\"^/nextgen/collection/([^/]+)(?:/(.*))?$\",\"paramNames\":[\"collection\",\"view\"],\"hasOptionalPrefix\":false},{\"path\":\"/nextgen/collection/:collection/art\",\"regex\":\"^/nextgen/collection/([^/]+)/art$\",\"paramNames\":[\"collection\"],\"hasOptionalPrefix\":false},{\"path\":\"/nextgen/collection/:collection/distribution-plan\",\"regex\":\"^/nextgen/collection/([^/]+)/distribution-plan$\",\"paramNames\":[\"collection\"],\"hasOptionalPrefix\":false},{\"path\":\"/nextgen/collection/:collection/mint\",\"regex\":\"^/nextgen/collection/([^/]+)/mint$\",\"paramNames\":[\"collection\"],\"hasOptionalPrefix\":false},{\"path\":\"/nextgen/collection/:collection/trait-sets\",\"regex\":\"^/nextgen/collection/([^/]+)/trait-sets$\",\"paramNames\":[\"collection\"],\"hasOptionalPrefix\":false},{\"path\":\"/nextgen/token/:token/:view*?\",\"regex\":\"^/nextgen/token/([^/]+)(?:/(.*))?$\",\"paramNames\":[\"token\",\"view\"],\"hasOptionalPrefix\":false},{\"path\":\"/rememes/:contract/:id\",\"regex\":\"^/rememes/([^/]+)/([^/]+)$\",\"paramNames\":[\"contract\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/the-memes/:id\",\"regex\":\"^/the-memes/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/the-memes/:id/distribution\",\"regex\":\"^/the-memes/([^/]+)/distribution$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/tools/app-wallets/:app-wallet-address\",\"regex\":\"^/tools/app-wallets/([^/]+)$\",\"paramNames\":[\"app-wallet-address\"],\"hasOptionalPrefix\":false},{\"path\":\"/waves/:wave\",\"regex\":\"^/waves/([^/]+)$\",\"paramNames\":[\"wave\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/6529-gradient\"},{\"path\":\"/about/100m-project\"},{\"path\":\"/about/media\"},{\"path\":\"/about/mission\"},{\"path\":\"/about/open-metaverse\"},{\"path\":\"/about/press\"},{\"path\":\"/about/rules\"},{\"path\":\"/accept-connection-sharing\"},{\"path\":\"/access\"},{\"path\":\"/author/6529er6529-io\"},{\"path\":\"/author/ladysabrina\"},{\"path\":\"/author/nft6529\"},{\"path\":\"/author/teexels\"},{\"path\":\"/blog/a-tale-of-two-artists\"},{\"path\":\"/blog/disney-deekay-their-secret-to-animation\"},{\"path\":\"/blog/from-fibonacci-to-fidenza\"},{\"path\":\"/buidl\"},{\"path\":\"/capital\"},{\"path\":\"/capital/company-portfolio\"},{\"path\":\"/capital/fund\"},{\"path\":\"/casabatllo\"},{\"path\":\"/category/blog\"},{\"path\":\"/category/news\"},{\"path\":\"/cdn-cgi/l/email-protection\"},{\"path\":\"/city/6529-museum-district\"},{\"path\":\"/consolidation-mapping-tool\"},{\"path\":\"/delegation-mapping-tool\"},{\"path\":\"/discover\"},{\"path\":\"/dispute-resolution\"},{\"path\":\"/drop-forge\"},{\"path\":\"/drop-forge/craft\"},{\"path\":\"/drop-forge/launch\"},{\"path\":\"/education\"},{\"path\":\"/education/education-collaboration-form\"},{\"path\":\"/education/podcasts\"},{\"path\":\"/education/tweetstorms\"},{\"path\":\"/element_category/columns\"},{\"path\":\"/element_category/sections\"},{\"path\":\"/email-signatures\"},{\"path\":\"/emma\"},{\"path\":\"/emma/plans\"},{\"path\":\"/error\"},{\"path\":\"/feed\"},{\"path\":\"/gm-or-die-small-mp4\"},{\"path\":\"/meme-accounting\"},{\"path\":\"/meme-calendar\"},{\"path\":\"/meme-gas\"},{\"path\":\"/meme-lab\"},{\"path\":\"/messages\"},{\"path\":\"/messages/create\"},{\"path\":\"/museum\"},{\"path\":\"/museum/1-of-1-art\"},{\"path\":\"/museum/6529-fam\"},{\"path\":\"/museum/6529-fam-2021\"},{\"path\":\"/museum/6529-fund-szn1\"},{\"path\":\"/museum/6529-fund-szn1/act-of-kindness\"},{\"path\":\"/museum/6529-fund-szn1/an-incomparable-love\"},{\"path\":\"/museum/6529-fund-szn1/archeology-of-the-future\"},{\"path\":\"/museum/6529-fund-szn1/azuki\"},{\"path\":\"/museum/6529-fund-szn1/ballad-of-ghosts\"},{\"path\":\"/museum/6529-fund-szn1/bored-ape-yacht-club\"},{\"path\":\"/museum/6529-fund-szn1/capsule-house\"},{\"path\":\"/museum/6529-fund-szn1/chromie-squiggle\"},{\"path\":\"/museum/6529-fund-szn1/clonex\"},{\"path\":\"/museum/6529-fund-szn1/cod\"},{\"path\":\"/museum/6529-fund-szn1/conflicting-metaphysics\"},{\"path\":\"/museum/6529-fund-szn1/construction-token\"},{\"path\":\"/museum/6529-fund-szn1/cryptoad-punks\"},{\"path\":\"/museum/6529-fund-szn1/cryptoadz\"},{\"path\":\"/museum/6529-fund-szn1/cryptocubes\"},{\"path\":\"/museum/6529-fund-szn1/cryptopunks\"},{\"path\":\"/museum/6529-fund-szn1/dead-ringers\"},{\"path\":\"/museum/6529-fund-szn1/entretiempos\"},{\"path\":\"/museum/6529-fund-szn1/fakerares\"},{\"path\":\"/museum/6529-fund-szn1/faraway\"},{\"path\":\"/museum/6529-fund-szn1/fidenza\"},{\"path\":\"/museum/6529-fund-szn1/gazers\"},{\"path\":\"/museum/6529-fund-szn1/genesis\"},{\"path\":\"/museum/6529-fund-szn1/grifters\"},{\"path\":\"/museum/6529-fund-szn1/image-with-arrow\"},{\"path\":\"/museum/6529-fund-szn1/incomplete-control\"},{\"path\":\"/museum/6529-fund-szn1/intensify-modeling\"},{\"path\":\"/museum/6529-fund-szn1/invisible-friends\"},{\"path\":\"/museum/6529-fund-szn1/jiometory-no-compute\"},{\"path\":\"/museum/6529-fund-szn1/madhouse\"},{\"path\":\"/museum/6529-fund-szn1/meridian\"},{\"path\":\"/museum/6529-fund-szn1/mfers\"},{\"path\":\"/museum/6529-fund-szn1/non-either\"},{\"path\":\"/museum/6529-fund-szn1/nouns\"},{\"path\":\"/museum/6529-fund-szn1/nuclear-nerds\"},{\"path\":\"/museum/6529-fund-szn1/primary-colors-of-neural-bricolage\"},{\"path\":\"/museum/6529-fund-szn1/proof-grails-protoglyph\"},{\"path\":\"/museum/6529-fund-szn1/proof-grails-wall\"},{\"path\":\"/museum/6529-fund-szn1/queens-kings\"},{\"path\":\"/museum/6529-fund-szn1/rarepepe\"},{\"path\":\"/museum/6529-fund-szn1/ringers\"},{\"path\":\"/museum/6529-fund-szn1/screens\"},{\"path\":\"/museum/6529-fund-szn1/subscapes\"},{\"path\":\"/museum/6529-fund-szn1/the-key-the-trial\"},{\"path\":\"/museum/6529-fund-szn1/twin-flames\"},{\"path\":\"/museum/6529-fund-szn1/videodrome\"},{\"path\":\"/museum/6529-fund-szn1/where-my-vans-go\"},{\"path\":\"/museum/6529-fund-szn1/wild-child-2022\"},{\"path\":\"/museum/6529-fund-szn1/xcopy\"},{\"path\":\"/museum/6529-fund-szn2\"},{\"path\":\"/museum/6529-general-assembly\"},{\"path\":\"/museum/6529-gradient-collector-curated\"},{\"path\":\"/museum/6529-photo-a\"},{\"path\":\"/museum/6529-photo-b\"},{\"path\":\"/museum/6529-public-domain\"},{\"path\":\"/museum/ac-museum\"},{\"path\":\"/museum/ack-bar\"},{\"path\":\"/museum/batsoupyum-museum-1\"},{\"path\":\"/museum/batsoupyum-museum-2\"},{\"path\":\"/museum/bharat-krymo-museum-1\"},{\"path\":\"/museum/bharat-krymo-museum-2\"},{\"path\":\"/museum/bharat-krymo-museum-3\"},{\"path\":\"/museum/bonafidehan-museum\"},{\"path\":\"/museum/early-nft-art\"},{\"path\":\"/museum/general-assembly\"},{\"path\":\"/museum/generative-art\"},{\"path\":\"/museum/genesis\"},{\"path\":\"/museum/genesis/27-bit-digital\"},{\"path\":\"/museum/genesis/720-minutes\"},{\"path\":\"/museum/genesis/aerial-view\"},{\"path\":\"/museum/genesis/algobots\"},{\"path\":\"/museum/genesis/algorhythms\"},{\"path\":\"/museum/genesis/apparitions\"},{\"path\":\"/museum/genesis/archetype\"},{\"path\":\"/museum/genesis/asemica\"},{\"path\":\"/museum/genesis/autoglyphs\"},{\"path\":\"/museum/genesis/autology\"},{\"path\":\"/museum/genesis/bent\"},{\"path\":\"/museum/genesis/bubble-bobbly\"},{\"path\":\"/museum/genesis/century\"},{\"path\":\"/museum/genesis/chimera\"},{\"path\":\"/museum/genesis/chromie-squiggle\"},{\"path\":\"/museum/genesis/construction-token\"},{\"path\":\"/museum/genesis/cosmic-reef\"},{\"path\":\"/museum/genesis/cryptoarte\"},{\"path\":\"/museum/genesis/cryptoblots\"},{\"path\":\"/museum/genesis/cryptocube\"},{\"path\":\"/museum/genesis/dreams\"},{\"path\":\"/museum/genesis/dynamic-slices\"},{\"path\":\"/museum/genesis/edifice\"},{\"path\":\"/museum/genesis/elementals\"},{\"path\":\"/museum/genesis/elevated-deconstructions\"},{\"path\":\"/museum/genesis/endless-nameless\"},{\"path\":\"/museum/genesis/entretiempos\"},{\"path\":\"/museum/genesis/fidenza\"},{\"path\":\"/museum/genesis/fragments-of-an-infinite-field\"},{\"path\":\"/museum/genesis/frammenti\"},{\"path\":\"/museum/genesis/gazers\"},{\"path\":\"/museum/genesis/genesis-dca\"},{\"path\":\"/museum/genesis/geometry-runners\"},{\"path\":\"/museum/genesis/glitch-crystal-monsters\"},{\"path\":\"/museum/genesis/great-hall-of-generative-art\"},{\"path\":\"/museum/genesis/hyperhash\"},{\"path\":\"/museum/genesis/ignition\"},{\"path\":\"/museum/genesis/incomplete-control\"},{\"path\":\"/museum/genesis/inspirals\"},{\"path\":\"/museum/genesis/jiometory-no-compute\"},{\"path\":\"/museum/genesis/kai-gen\"},{\"path\":\"/museum/genesis/labios\"},{\"path\":\"/museum/genesis/lost-robbies\"},{\"path\":\"/museum/genesis/meridian\"},{\"path\":\"/museum/genesis/nimbuds\"},{\"path\":\"/museum/genesis/para-bellum\"},{\"path\":\"/museum/genesis/phase\"},{\"path\":\"/museum/genesis/pigments\"},{\"path\":\"/museum/genesis/ringers\"},{\"path\":\"/museum/genesis/screens\"},{\"path\":\"/museum/genesis/scribbled-boundaries\"},{\"path\":\"/museum/genesis/secret-surprise\"},{\"path\":\"/museum/genesis/singularity\"},{\"path\":\"/museum/genesis/skulptuur\"},{\"path\":\"/museum/genesis/spectron\"},{\"path\":\"/museum/genesis/squiggly-wtf\"},{\"path\":\"/museum/genesis/subscapes\"},{\"path\":\"/museum/genesis/synapses\"},{\"path\":\"/museum/genesis/the-blocks-of-art\"},{\"path\":\"/museum/genesis/trossets\"},{\"path\":\"/museum/genesis/unigrids\"},{\"path\":\"/museum/genesis/vortex\"},{\"path\":\"/museum/genesis/watercolor-dreams\"},{\"path\":\"/museum/genesis/willow-shield\"},{\"path\":\"/museum/imagined-worlds\"},{\"path\":\"/museum/nft-photography\"},{\"path\":\"/museum/sozet-lounge\"},{\"path\":\"/museum/sunshine-square\"},{\"path\":\"/museum/temple-of-gm\"},{\"path\":\"/museum/the-institutions\"},{\"path\":\"/museum/yongoh-kim\"},{\"path\":\"/network\"},{\"path\":\"/network/activity\"},{\"path\":\"/network/definitions\"},{\"path\":\"/network/groups\"},{\"path\":\"/network/health\"},{\"path\":\"/network/health/network-tdh\"},{\"path\":\"/network/levels\"},{\"path\":\"/network/prenodes\"},{\"path\":\"/network/tdh\"},{\"path\":\"/network/tdh/historic-boosts\"},{\"path\":\"/network/xtdh\"},{\"path\":\"/news/introducing-om\"},{\"path\":\"/nextgen/manager\"},{\"path\":\"/nft-activity\"},{\"path\":\"/notifications\"},{\"path\":\"/om\"},{\"path\":\"/om/6529-museum-district\"},{\"path\":\"/om/OM\"},{\"path\":\"/om/community-galleries\"},{\"path\":\"/om/instruction-manual\"},{\"path\":\"/om/join-om\"},{\"path\":\"/om/om-groups\"},{\"path\":\"/om/partnership-request\"},{\"path\":\"/open-data\"},{\"path\":\"/open-data/meme-subscriptions\"},{\"path\":\"/open-data/network-metrics\"},{\"path\":\"/open-data/rememes\"},{\"path\":\"/open-data/royalties\"},{\"path\":\"/open-data/team\"},{\"path\":\"/open-mobile\"},{\"path\":\"/rememes\"},{\"path\":\"/rememes/add\"},{\"path\":\"/restricted\"},{\"path\":\"/sentry-example-page\"},{\"path\":\"/slide-page/6529-initiatives\"},{\"path\":\"/slide-page/homepage-slider\"},{\"path\":\"/the-memes\"},{\"path\":\"/the-memes/mint\"},{\"path\":\"/tools/api\"},{\"path\":\"/tools/app-wallets\"},{\"path\":\"/tools/app-wallets/import-wallet\"},{\"path\":\"/tools/block-finder\"},{\"path\":\"/tools/subscriptions-report\"},{\"path\":\"/waves\"},{\"path\":\"/waves/create\"},{\"path\":\"/xtdh\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import { publicEnv } from "@/config/env";
import {
  INDEXEDDB_ERROR_MESSAGE,
  isIndexedDBError,
} from "@/utils/error-sanitizer";
import {
  sanitizeSentryBreadcrumb,
  sanitizeSentryEvent,
  sanitizeUrlString,
} from "@/utils/sentry-sanitizer";
import {
  getThirdPartyTelemetrySpanTargetKey,
  shouldFilterByFilenameExceptions,
  shouldFilterInjectedWalletCollision,
  shouldFilterThirdPartyTelemetrySpan,
  shouldFilterTwitterConfigReferenceError,
  type SentryTransactionSpan,
} from "@/utils/sentry-client-filters";
import * as Sentry from "@sentry/nextjs";

const sentryEnabled = !!publicEnv.SENTRY_DSN;
const isProduction = publicEnv.NODE_ENV === "production";
const dsn = publicEnv.SENTRY_DSN;
const replayEnabled =
  sentryEnabled && isProduction && publicEnv.SENTRY_REPLAY_ENABLED === "true";

const noisyPatterns = [
  "EmptyRanges",
  "ResizeObserver loop limit exceeded",
  "Non-Error promise rejection captured",
];

const referenceErrors = ["__firefox__"];

const URL_REGEX = /\(([^)]+?)\)/;
type SentryTransactionEvent = Sentry.Event & {
  spans?: SentryTransactionSpan[] | undefined;
  tags?: Record<string, unknown> | undefined;
  extra?: Record<string, unknown> | undefined;
};

function getFallbackMessage(hint?: Sentry.EventHint): string {
  if (typeof hint?.originalException === "string") {
    return hint.originalException;
  }
  if (hint?.originalException instanceof Error) {
    return hint.originalException.message;
  }
  return "";
}

function shouldFilterNoisyPatterns(message: string): boolean {
  return noisyPatterns.some((p) => message.includes(p));
}

function shouldFilterReferenceErrors(
  message: string,
  errorType: string | undefined
): boolean {
  if (errorType !== "ReferenceError" && errorType !== "TypeError") {
    return false;
  }
  return referenceErrors.some((p) => message.includes(p));
}

function shouldFilterEvent(
  event: Sentry.Event,
  hint?: Sentry.EventHint
): boolean {
  const value = event.exception?.values?.[0];
  const fallbackMessage = getFallbackMessage(hint);
  const message = value?.value ?? fallbackMessage;

  if (typeof message === "string") {
    if (shouldFilterNoisyPatterns(message)) {
      return true;
    }
    if (shouldFilterReferenceErrors(message, value?.type)) {
      return true;
    }
  }

  if (shouldFilterInjectedWalletCollision(event, hint)) {
    return true;
  }

  if (shouldFilterTwitterConfigReferenceError(event)) {
    return true;
  }

  const frames = event.exception?.values?.[0]?.stacktrace?.frames;
  return shouldFilterByFilenameExceptions(frames, hint);
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function filterNoisyThirdPartyTransactionSpans(
  event: Sentry.Event
): Sentry.Event {
  const transactionEvent = event as SentryTransactionEvent;
  const spans = transactionEvent.spans;
  if (!Array.isArray(spans) || spans.length === 0) {
    return event;
  }

  const filteredSpanKeys = new Set<string>();
  const keptSpans = spans.filter((span) => {
    if (!shouldFilterThirdPartyTelemetrySpan(span)) {
      return true;
    }

    const targetKey = getThirdPartyTelemetrySpanTargetKey(span);
    if (targetKey) {
      filteredSpanKeys.add(targetKey);
    }
    return false;
  });

  if (keptSpans.length === spans.length) {
    return event;
  }

  const existingTags = isRecord(transactionEvent.tags)
    ? transactionEvent.tags
    : {};
  const existingExtra = isRecord(transactionEvent.extra)
    ? transactionEvent.extra
    : {};

  const nextEvent: SentryTransactionEvent = {
    ...transactionEvent,
    spans: keptSpans,
    tags: {
      ...existingTags,
      third_party_span_noise_filtered: "true",
    },
    extra: {
      ...existingExtra,
      filteredThirdPartySpanCount: spans.length - keptSpans.length,
      filteredThirdPartySpanKeys: Array.from(filteredSpanKeys).sort(
        (left, right) => left.localeCompare(right)
      ),
    },
  };

  return nextEvent;
}

function handleIndexedDBError(event: Sentry.Event): void {
  event.level = "warning";
  event.tags = {
    ...event.tags,
    errorType: "indexeddb",
    handled: true,
  };
  event.fingerprint = ["indexeddb-connection-lost"];
}

function extractUrlFromError(error: TypeError, event: Sentry.Event): string {
  const urlMatch = URL_REGEX.exec(error.message.slice(0, 2048));
  if (urlMatch?.[1]) {
    return String(sanitizeUrlString(urlMatch[1]));
  }

  const fetchBreadcrumb = event.breadcrumbs?.find(
    (crumb) => crumb.category === "fetch" || crumb.type === "http"
  );
  if (fetchBreadcrumb?.data?.["url"]) {
    return String(sanitizeUrlString(fetchBreadcrumb.data["url"]));
  }
  if (event.request?.url) {
    return String(sanitizeUrlString(event.request.url));
  }
  return "unknown";
}

function isNetworkError(errorMessage: string): boolean {
  const normalized = errorMessage.toLowerCase();
  return (
    normalized.includes("failed to fetch") ||
    normalized.includes("load failed") ||
    normalized.includes("networkerror") ||
    normalized.includes("network error") ||
    normalized.includes("network request failed") ||
    /\bnetwork\b/.test(normalized)
  );
}

function handleNetworkError(
  event: Sentry.Event,
  error: TypeError,
  value: Sentry.Exception | undefined
): void {
  if (!isNetworkError(error.message)) {
    return;
  }

  const url = extractUrlFromError(error, event);
  const normalized = error.message.toLowerCase();
  const transformedMessage = normalized.includes("network")
    ? `Network error: ${error.message} (${url})`
    : `Network request failed. Please check your connection and try again. (${url})`;

  if (value) {
    value.value = transformedMessage;
  }
  if (event.message) {
    event.message = transformedMessage;
  }

  event.level = "warning";
  event.tags = {
    ...event.tags,
    errorType: "network",
    handled: true,
  };
  event.fingerprint = ["network-error"];
}

Sentry.init({
  ...(dsn && { dsn }),
  enabled: sentryEnabled,

  integrations(integrations) {
    if (!replayEnabled) return integrations;
    return [...integrations, Sentry.replayIntegration()];
  },

  tracesSampleRate: 0.1,

  enableLogs: true,

  // Session Replay is opt-in because it can capture sensitive user content.
  replaysSessionSampleRate: replayEnabled ? 0.1 : 0,

  replaysOnErrorSampleRate: replayEnabled ? 1.0 : 0,

  // Default to NOT sending PII unless explicitly reviewed and required.
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: false,

  beforeBreadcrumb(breadcrumb) {
    return sanitizeSentryBreadcrumb(breadcrumb);
  },

  beforeSend(event, hint) {
    if (shouldFilterEvent(event, hint)) {
      return null;
    }

    const error = hint?.originalException ?? hint?.syntheticException;
    const value = event.exception?.values?.[0];
    const message =
      (typeof value?.value === "string" && value.value) ||
      getFallbackMessage(hint) ||
      (typeof event.message === "string" ? event.message : "");

    if (
      (error && isIndexedDBError(error)) ||
      (message && isIndexedDBError(message))
    ) {
      handleIndexedDBError(event);
    }

    if (error instanceof TypeError) {
      handleNetworkError(event, error, value);
    }

    return sanitizeSentryEvent(event);
  },

  beforeSendTransaction(event) {
    return sanitizeSentryEvent(
      filterNoisyThirdPartyTransactionSpans(event) as any
    );
  },
});

if (globalThis.window !== undefined) {
  globalThis.window.addEventListener("error", (event) => {
    if (isIndexedDBError(event.error)) {
      event.preventDefault();
      console.warn(`[IndexedDB] ${INDEXEDDB_ERROR_MESSAGE}`, event.error);
    }
  });

  globalThis.window.addEventListener("unhandledrejection", (event) => {
    if (isIndexedDBError(event.reason)) {
      event.preventDefault();
      console.warn(
        `[IndexedDB] Unhandled promise rejection: ${INDEXEDDB_ERROR_MESSAGE}`,
        event.reason
      );
    }
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
